import { Button } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { changeMenu, onResetLayerAll, showMenuPopup } from "../../../redux/actions/menu.action";
import "./menu.scss";
import Popup from "./Popup";
import ModalCustom from '../../CustomsAntd/ModalCustom/ModalCustom';
import { changeMapLayer, resetMapLayer } from '../../../redux/actions/map.action';

export class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      typeRender: "default",

      isOpenPopup: false,
      isShowSearch: false,
      popupType: undefined,
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if(prevProps.isShowMenuPopup !== this.props.isShowMenuPopup){
      this.setState({
        isOpenPopup: this.props.isShowMenuPopup
      })
    }
    if (prevProps.isResetLayer !== this.props.isResetLayer) {
      this.onResetLayerAll()
    }
  }

  explandMenu(type) {
    this.setState({
      typeRender: this.state.typeRender === "default" ? "mini" : "default",
    });
    this.props.changeMenu(type === 'open');
  }

  handleClickIntroduce = () => {
    this.setState({
      isOpenPopup: true,
      popupType: "introduce",
    });
    this.props.showMenuPopup(true)
  };

  handleClickTutorial = () => {
    this.setState({
      isOpenPopup: true,
      popupType: "tutorial",
    });
    this.props.showMenuPopup(true)
  };

  handleClosePopup = () => {
    this.setState({
      isOpenPopup: false,
      popupType: undefined,
    });
  };
  onResetLayerAll = () => {
    this.setState({
      searchChiTiet: false,
      searchPhanKhu:false,
      searchChung: false,
      searchKienTruc: false
    })
    this.props.changeMapLayer(["RanhGioiDiaChinh", "BienSoNha"]);

    this.props.resetMapLayer()
    this.props.history.push("/");
  }

  render() {
    return (
      <div className="menu">
        {this.state.typeRender === "default" ? (
          <div className="default-menu">
            <div>
              <div
                className={
                  this.state.popupType && this.state.popupType === "introduce"
                    ? "menu-item-active"
                    : "menu-item"
                }
                onClick={this.handleClickIntroduce}
              >
                <i className="fas fa-book icon-description" />
                <div className="item-text">Giới thiệu phần mềm</div>
              </div>

              <div
                className={
                  this.state.popupType && this.state.popupType === "tutorial"
                    ? "menu-item-active"
                    : "menu-item"
                }
                onClick={this.handleClickTutorial}
              >
                <i className="fas fa-file-video icon-description"></i>
                <div className="item-text">Hướng dẫn sử dụng</div>
              </div>

              {/* <div className="menu-item" 
                onClick={() => {
                  // this.explandMenu('close');
                  // this.props.history.push("/");
                }}
              >
                <i className="fas fa-search icon-description"></i>
                <div className="item-text">Tra cứu</div>
              </div> */}

              {this.state.TraCuu ? (
                <div
                  className="menu-item-active"
                  onClick={() => {
                    this.setState(prevState => {
                      return {
                        isShowSearch: !prevState.isShowSearch
                      }
                    })
                  }}
                >
                  <i className="fas fa-search icon-description"></i>
                  <div className="item-text">Tra cứu</div>
                </div>
              ) : (
                <div
                  className="menu-item"
                  onClick={() => {
                    this.setState(prevState => {
                      return {
                        isShowSearch: !prevState.isShowSearch
                      }
                    })
                  }}
                >
                  <i className="fas fa-search icon-description"></i>
                  <div className="item-text">Tra cứu</div>
                </div>
              )}
                {this.state.isShowSearch ? (
                    <div className="sub-menu">
                      {this.state.searchChiTiet ? (
                        <div className="sub-menu-item-active">
                          <i className="fas fa-th icon-description"></i>
                          <div className="sub-item-text-active">
                            Quy hoạch chi tiết 1/500
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.props.changeMapLayer(["QHCT_Polygon"
                            // , "QHCT_Line", "QHCT_RanhGioi"
                          ]);
                            this.setState(prevState => {
                              return {
                                searchChiTiet: true,
                                searchPhanKhu:false,
                                searchChung: false,
                                searchKienTruc: false
                              }
                            })
                          }}
                        >
                          <i className="fas fa-th icon-description"></i>
                          <div className="sub-item-text">Quy hoạch chi tiết 1/500</div>
                        </div>
                      )}

                      {this.state.searchPhanKhu ? (
                        <div className="sub-menu-item-active">
                          <i className="fas fa-th icon-description"></i>
                          <div>
                            <div className="sub-item-text-active">
                            Quy hoạch phân khu 1/5000
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.props.changeMapLayer(["QHPK_Polygon"
                            // , "QHPK_Line", "QHPK_RanhGioi"
                          ]);
                            this.setState(prevState => {
                              return {
                                searchChiTiet: false,
                                searchPhanKhu:true,
                                searchChung: false,
                                searchKienTruc: false
                              }
                            })
                          }}
                        >
                          <i className="fas fa-th icon-description"></i>
                          <div>
                            <div className="sub-item-text">
                            Quy hoạch phân khu 1/5000
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.searchChung ? (
                        <div className="sub-menu-item-active">
                          <i className="fas fa-th icon-description"></i>
                          <div>
                            <div className="sub-item-text-active">
                            Quy hoạch chung 1/10000
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.props.changeMapLayer(["QHC_Polygon", "QHC_HienTrang"
                            // , "QHC_Line", "QHC_RanhGioiQuyHoach"
                          ]);
                            this.setState(prevState => {
                              return {
                                searchChiTiet: false,
                                searchPhanKhu:false,
                                searchChung: true,
                                searchKienTruc: false
                              }
                            })
                          }}
                        >
                          <i className="fas fa-th icon-description"></i>
                          <div>
                            <div className="sub-item-text">
                            Quy hoạch chung 1/10000
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.searchKienTruc ? (
                        <div className="sub-menu-item-active">
                          <i className="fas fa-th icon-description"></i>
                          <div>
                            <div className="sub-item-text-active">
                            Kiến trúc
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.props.changeMapLayer(["KienTruc"]);
                            this.setState(prevState => {
                              return {
                                searchChiTiet: false,
                                searchPhanKhu:false,
                                searchChung: false,
                                searchKienTruc: true
                              }
                            })
                          }}
                        >
                          <i className="fas fa-th icon-description"></i>
                          <div>
                            <div className="sub-item-text">
                            Kiến trúc
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : null}

              <div className="menu-item" 
                onClick={() => {
                  this.props.onResetLayerAll()
                }}
              >
                <i className="fas fa-times-circle icon-description"></i>
                <div className="item-text">Thoát</div>
              </div>

              <div className="menu-bottom">
                <Button className="download-item"  onClick={() => {
                    window.open('https://play.google.com/store/apps/details?id=com.ttqhSoXayDung', "_blank");
                  }}>
                  <img src="/images/IconSvg/Icon/android.png" alt="" />
                  <div className="text-download">
                    <div className="text">Tải ứng dụng </div>
                    <div className="text">hệ điều hành Android</div>
                  </div>
                </Button>

                <Button className="download-item"onClick={() => {
                    window.open('https://apps.apple.com/vn/app/ttqh-%C4%91%C3%A0-n%E1%BA%B5ng/id1559033028?ign-itscg=30200&ign-itsct=apps_box_link#?platform=iphone', "_blank");
                  }}>
                  <img src="/images/IconSvg/Icon/iso.png" alt="" />
                  <div className="text-download">
                    <div className="text">Tải ứng dụng </div>
                    <div className="text">hệ điều hành IOS</div>
                  </div>
                </Button>
              </div>
            </div>

            <div className="resize">
              <div
                className="button-resize"
                onClick={() => {
                  this.explandMenu('close');
                }}
              >
                <i
                  className="fas fa-chevron-circle-left"
                  style={{ fontSize: "24px" }}
                ></i>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="mini-menu"
            // onDoubleClick={() => {
            //   this.explandMenu();
            // }}
          >
            <div>
              <Button
                className={
                  this.state.popupType && this.state.popupType === "introduce"
                    ? "button-menu-active"
                    : "button-menu"
                }
                onClick={this.handleClickIntroduce}
              >
                <i className="fas fa-book icon-description" />
              </Button>

              <Button
                className={
                  this.state.popupType && this.state.popupType === "tutorial"
                    ? "button-menu-active"
                    : "button-menu"
                }
                onClick={this.handleClickTutorial}
              >
                <i className="fas fa-file-video icon-description" />
              </Button>

              <Button
                  className="button-mini"
                  onClick={() => {
                    this.explandMenu('close');
                    // this.props.history.push("/");
                  }}
                >
                <i className="fas fa-search icon-description" />
              </Button>

              <Button
                  className="button-mini"
                  onClick={() => {
                    // this.explandMenu('close');
                    this.props.onResetLayerAll()
                  }}
                >
                  <i className="fas fa-times-circle icon-description" />
                </Button>

              <div className="mini-menu-bottom">
                <Button className="button-circle" 
                  onClick={() => {
                    window.open('https://play.google.com/store/apps/details?id=com.ttqhSoXayDung', "_blank");
                  }}
                >
                  <img
                    src="/images/IconSvg/Icon/android.png"
                    alt=""
                    style={{ width: "40px", height: "40px" }}
                  />
                </Button>
                <Button className="button-circle"
                  onClick={() => {
                    window.open('https://apps.apple.com/vn/app/ttqh-%C4%91%C3%A0-n%E1%BA%B5ng/id1559033028?ign-itscg=30200&ign-itsct=apps_box_link#?platform=iphone', "_blank");
                  }}
                >
                  <img
                    src="/images/IconSvg/Icon/iso.png"
                    alt=""
                    style={{ width: "40px", height: "40px" }}
                  />
                </Button>
              </div>
            </div>

            <div className="resize">
              <div
                className="button-resize"
                onClick={() => {
                  this.explandMenu('open');
                }}
              >
                <i
                  className="fas fa-chevron-circle-right"
                  style={{ fontSize: "24px" }}
                ></i>
              </div>
            </div>
          </div>
        )}
        <ModalCustom
          visible={this.state.isOpenPopup}
          onCancel={this.handleClosePopup}
          width={800}
        >
          <Popup 
            close={this.handleClosePopup}
            type={this.state.popupType} 
            typeMenu={this.state.typeRender}
          />
        </ModalCustom>
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isShowMenu: state.menu.isShowMenu,
    isResetLayer: state.menu.isResetLayer,
    isShowMenuPopup: state.menu.isShowMenuPopup
  };
};

const mapDispatchToProps = {
  changeMenu: changeMenu,
  changeMapLayer: changeMapLayer,
  showMenuPopup: showMenuPopup,
  resetMapLayer: resetMapLayer,
  onResetLayerAll: onResetLayerAll
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
